<!-- Dedicated wrapper so Chart.js responsive sizing measures it, not :host. -->
<div class="canvas-wrap">
    <canvas #ganttCanvas class="gantt-canvas" role="img" [attr.aria-label]="ariaLabel"></canvas>
</div>

<!-- Caveat for suppressed rows. Intentionally printable — it must reach the shared report. -->
<div *ngIf="suppressedCount" class="gantt-cross-year-note">
    <mat-icon class="material-symbols-outlined note-icon">info</mat-icon>
    <span>
        <ng-container *ngIf="wrapsAxisCount">
            * {{ wrapsAxisCount }} row{{ wrapsAxisCount === 1 ? '' : 's' }}
            cross{{ wrapsAxisCount === 1 ? 'es' : '' }} the start of this axis and can't be drawn here —
            try switching the axis start in the chart settings.
        </ng-container>
        <ng-container *ngIf="multiSeasonCount">
            {{ wrapsAxisCount ? ' ' : '* ' }}{{ multiSeasonCount }} row{{ multiSeasonCount === 1 ? '' : 's' }}
            cover{{ multiSeasonCount === 1 ? 's' : '' }} more than one season and can't be shown as a single bar.
        </ng-container>
        The dates are correct in your data — only the bar is hidden.
    </span>
</div>
